import React from 'react';

import { useNavigate } from 'react-router-dom';
import { i18n, RootState, useAppSelector } from 'src/common';
import { OfferHealthQuestionnaireType } from 'src/common/api/apollo/additional/types/types';
import { BackLink, Button, Flex } from 'src/components';
import { AppRoutesAdditional } from 'src/pages/app';
import { Text } from '../../typography';
import { Card } from '../card';

export interface HealthQuestionnaireFinishedCardProps {
  healthQuestionnaire: OfferHealthQuestionnaireType;
  offerId: string;
  isConfirmed: boolean;
}

export const HealthQuestionnaireFinishedCard: React.FC<HealthQuestionnaireFinishedCardProps> = ({
  healthQuestionnaire,
  offerId,
  isConfirmed,
}) => {
  const navigate = useNavigate();
  const flow = useAppSelector((store: RootState) => store.state.flow);
  const soId = useAppSelector((store: RootState) => store.model.offer.soIdWeb);
  const backPath =
    flow.flowType === 'agent'
      ? `${AppRoutesAdditional.AGENT_OFFERS_PREVIEW.fullPath}/${soId}`
      : AppRoutesAdditional.OFFERS_PREVIEW.fullPath;


  return (
    <Flex vertical gap={24}>
      <Card>
        <Flex vertical gap={24} align="start">
          <Text type="large" bold>
            {i18n.t('pages.healthQuestionnaireFinished.title')}
          </Text>
          <Text type="base">
            {i18n.t('pages.healthQuestionnaireFinished.description')}
          </Text>
          <Flex justify="flex-end" style={{ width: '100%', alignSelf: 'stretch' }}>
            <Button
              btnType="primary"
              text={i18n.t('pages.healthQuestionnaireFinished.button')}
              onClick={() => {
                if (healthQuestionnaire.rejected) {
                  navigate(`${AppRoutesAdditional.HEALTH_QUESTIONNAIRE_REJECTED.fullPath}/${offerId}`);
                } else if (!isConfirmed) {
                  navigate(`${AppRoutesAdditional.HEALTH_QUESTIONNAIRE_NEEDS_CONFIRMATION.fullPath}/${offerId}`);
                } else {
                  navigate(`${AppRoutesAdditional.OFFER.fullPath}/${offerId}`);
                }
              }}
            />
          </Flex>
        </Flex>
      </Card>
      <Flex justify="center">
        <BackLink
          text={i18n.t('pages.offersAdditionalPage.backLink')}
          path={backPath}
        />
      </Flex>
    </Flex>
  );
};
